export const setElementPositionForBanner = ({ selector, value, property, }) => {
    const element = window.document.querySelector(selector);
    if (element) {
        element.style[property] = value;
    }
};
export const setStickyBanner = (isTop, height) => {
    window.document.body.classList.add(isTop ? "body--top-health-banner" : "body--bottom-health-banner");
    setElementPositionForBanner({
        selector: isTop ? ".header__container" : "#footer",
        value: height,
        property: isTop ? "top" : "marginBottom",
    });
};
export const setTopPositionBanner = (height) => {
    setElementPositionForBanner({
        selector: "body",
        value: height,
        property: "marginTop",
    });
};
export const waitForDynamicElementAndApplySpacing = (dynamicElementSelector, targetSelector) => {
    const dynamicElement = window.document.querySelector(dynamicElementSelector);
    if (dynamicElement === null || targetSelector.length === 0) {
        return;
    }
    const observer = new MutationObserver((_mutationsList, observer) => {
        const computedStyle = getComputedStyle(dynamicElement);
        if (computedStyle.display === "none") {
            return;
        }
        const offsetHeight = dynamicElement.offsetHeight ?? 0;
        setElementPositionForBanner({
            selector: targetSelector,
            value: `${offsetHeight}px`,
            property: "paddingBottom",
        });
        observer.disconnect();
    });
    observer.observe(dynamicElement, {
        childList: true,
        subtree: true,
    });
};
//# sourceMappingURL=helpers.js.map